import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PageableRequest } from 'src/app/admin-api';
import { StorageService } from 'src/app/services/auth/storage.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BfluGlamgirlSignupReportService {
  constructor(private http: HttpClient) {}

  getMappedReprocess(body: PageableRequest): Observable<{ result: unknown }> {
    return this.http.put<{ result: unknown }>(
      `${environment.apiUrl}/financial/reprocess/mapped`,
      body,
      {
        headers: new HttpHeaders({
          Authorization: 'Bearer ' + StorageService.token
        })
      }
    );
  }

  getCompletedReprocess(body: PageableRequest): Observable<{ result: unknown }> {
    return this.http.put<{ result: unknown }>(
      `${environment.apiUrl}/financial/reprocess/completed`,
      body,
      {
        headers: new HttpHeaders({
          Authorization: 'Bearer ' + StorageService.token
        })
      }
    );
  }

  getBfluGlamgirlSignupReports(
    body: PageableRequest
  ): Observable<{ result: unknown }> {
    return this.http.put<{ result: unknown }>(
      `${environment.apiUrl}/financial/bflu-glamgirl-signup-reports`,
      body,
      {
        headers: new HttpHeaders({
          Authorization: 'Bearer ' + StorageService.token
        })
      }
    );
  }
}
